import { BaseSettingsScreen } from '../screen/BaseSettingsScreen';

export class DevSettingsScreenEntity extends BaseSettingsScreen {
  readonly type = 'dev-settings';
}
